<template>
  <div>
    <div v-if="is_mobile()">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <router-link :to="{ name: 'results' }">
          <span class="vb-detail__back">indietro</span>
        </router-link>
        <div class="vb-detail__head-brand">
          <img :src="brand_logo" :alt="brand.name" />
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between mb-2">
        <div class="vb-detail__head-city">
          <vb-icon
            class="mr-1"
            :name="'pin'"
            :size="14"
            :color="sass('gray-500')"
          /><span class="text-capitalize">{{ header.location_label }}</span>
          <span v-if="show_open_in_maps" class="ml-2">
            <open-in-maps
              :location="maps_location"
              :only_use_coordinates="only_use_coordinates"
            />
          </span>
        </div>

        <div v-if="header.stars" class="vb-detail__head-star">
          <b-form-rating
            no-border
            inline
            readonly
            variant="secondary"
            :value="header.stars"
          />
        </div>
      </div>

      <div class="vb-detail__head mb-4">
        <h1>{{ header.name }}</h1>
        <div v-if="header.alpitour_rating" class="vb-detail__head-rate">
          <span class="mr-2">Valutazione Alpitour</span>
          <div>
            <b-form-rating
              no-border
              inline
              readonly
              variant="secondary"
              icon-empty="circle"
              icon-half="circle-half"
              icon-full="circle-fill"
              size="sm"
              :color="sass('gray-600')"
              :value="header.alpitour_rating"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <router-link :to="{ name: 'results' }">
        <span class="vb-detail__back">indietro</span>
      </router-link>

      <div class="mt-1 d-flex align-items-start">
        <h1 class="mr-2 mb-1">{{ header.name }}</h1>
        <div v-if="header.stars" class="vb-detail__head-star">
          <b-form-rating
            no-border
            inline
            readonly
            variant="secondary"
            :value="header.stars"
          />
        </div>
      </div>

      <div class="vb-detail__head mb-3">
        <div class="d-flex align-items-center">
          <div class="vb-detail__head-city">
            <vb-icon
              class="mr-1"
              :name="'pin'"
              :size="14"
              :color="sass('gray-500')"
            /><span class="text-capitalize">{{ header.location_label }}</span>
            <span v-if="show_open_in_maps" class="ml-2">
              <open-in-maps
                :location="maps_location"
                :only_use_coordinates="only_use_coordinates"
              />
            </span>
          </div>

          <div v-if="header.alpitour_rating" class="vb-detail__head-rate">
            <img
              class="mr-2"
              src="assets/images/alpitour/liveat-brands/Alpitour-World_logo_grigio.png"
            />
            <span class="mr-2">Valutazione Alpitour</span>
            <div>
              <b-form-rating
                no-border
                inline
                readonly
                variant="secondary"
                icon-empty="circle"
                icon-half="circle-half"
                icon-full="circle-fill"
                size="sm"
                :color="sass('gray-600')"
                :value="header.alpitour_rating"
              />
            </div>
          </div>
        </div>

        <div class="vb-detail__head-brand">
          <img :src="brand_logo" :alt="brand.name" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { get_config, is_mobile } from '@utilities/commons';
  import { get_brand } from '@alpitour/resources';
  import OpenInMaps from '@/components/atoms/open-in-maps.vue';

  export default {
    name: 'detail-header',

    components: {
      'open-in-maps': OpenInMaps,
    },

    props: {
      header: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      brand() {
        return get_brand(this.header.brand);
      },

      brand_logo() {
        return `assets/images/alpitour/liveat-brands/${this.brand.logo}`;
      },

      show_open_in_maps() {
        const { location } = this.header;
        return Boolean(
          location &&
            get_config('guiSettings.customizations.showOpenInMap', true)
        );
      },

      only_use_coordinates() {
        return get_config(
          'guiSettings.customizations.openMapWithOnlyCoordinates',
          false
        );
      },

      maps_location() {
        const { location = {}, name, location_label } = this.header;
        return { ...location, name, city: location_label };
      },
    },

    created() {
      this.is_mobile = is_mobile;
    },
  };
</script>
